import { useCallback } from 'react'

import { useInfiniteQuery } from '@tanstack/react-query'

import axios from 'axios'

const ENDPOINT = '/api/internal/generator/acquired-models'
const PER_PAGE = 10

/**
 * Paginated feed of the models the user has acquired, backing the picker grid.
 */
export default function useAcquiredModels(isLoggedIn, keywords) {
  const normalizedKeywords = (keywords ?? '').trim()

  const {
    data,
    hasNextPage: queryHasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
  } = useInfiniteQuery({
    queryKey: ['acquiredModels', normalizedKeywords],
    queryFn: async ({ pageParam = 1 }) => {
      const params = { page: pageParam, per_page: PER_PAGE }
      if (normalizedKeywords.length > 0) {
        params.keywords = normalizedKeywords
      }

      const { data: responseData } = await axios.get(ENDPOINT, { params })

      return {
        items: responseData.items || [],
        meta: responseData.meta || {},
      }
    },
    getNextPageParam: (lastPage, allPages) => {
      const { currentPage, totalPages } = lastPage.meta
      return currentPage < totalPages ? allPages.length + 1 : undefined
    },
    initialPageParam: 1,
    enabled: isLoggedIn === true,
  })

  const handleLoadMore = useCallback(() => {
    fetchNextPage()
  }, [fetchNextPage])

  return {
    items: data?.pages?.flatMap(page => page.items) ?? [],
    meta: data?.pages?.slice(-1)[0]?.meta,
    hasNextPage: queryHasNextPage ?? false,
    handleLoadMore,
    isFetchingNextPage,
    isLoading,
    isError,
  }
}
